export default __webpack_public_path__ + "static/media/form3.5cc62b39.svg";